import logomark from "@/assets/logomark.png";
import { STATES } from "@/config/states";
import { WaitlistInline } from "./WaitlistInline";

const ELIGIBLE_STATES = STATES.filter((s) => s.eligible);
const COLS = [
  {
    title: "Treatments",
    links: ["GLP-1 weight care", "Peptides", "Longevity", "Hormones", "Whole health", "Microdosing"],
  },
  {
    title: "Company",
    links: ["About", "Science", "Clinicians", "Press", "Careers", "Contact"],
  },
  {
    title: "Members",
    links: ["Sign in", "Refill a script", "Lab results", "Refer a friend", "Support"],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-background pt-20 pb-[calc(96px+env(safe-area-inset-bottom))] md:pb-10">
      <div className="container-wide">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-border/60">
          <div className="lg:col-span-4">
            <a href="#" className="flex items-center gap-2.5">
              <img src={logomark} alt="" width={28} height={28} className="size-6" />
              <span className="font-display text-xl text-foreground">Olive Health</span>
              <span className="relative flex size-2 ml-1.5" aria-hidden>
                <span className="absolute inset-0 rounded-full bg-accent/60 motion-safe:animate-pulse-soft" />
                <span className="relative inline-flex size-2 rounded-full bg-accent" />
              </span>
            </a>
            <p className="mt-5 text-sm text-foreground/65 max-w-xs leading-relaxed">
              Performance medicine, prescribed by clinicians and built around you.
            </p>
            <div className="mt-7 max-w-sm">
              <WaitlistInline placement="footer" label="Get launch updates" compact />
            </div>
          </div>
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-10">
            {COLS.map((c) => (
              <div key={c.title}>
                <h3 className="text-xs uppercase tracking-[0.2em] text-foreground/65 mb-4">
                  {c.title}
                </h3>
                <ul className="space-y-2.5">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#" className="text-sm text-foreground/70 hover:text-foreground">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <h3 className="text-xs uppercase tracking-[0.2em] text-foreground/65 mb-4">
            Available in
          </h3>
          <ul className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-1.5">
            {ELIGIBLE_STATES.map((s) => (
              <li key={s.code}>
                <a
                  href={`/states/${s.slug}`}
                  className="text-xs text-foreground/60 hover:text-foreground transition"
                >
                  {s.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-6 text-xs text-foreground/70">
          <p>© {new Date().getFullYear()} Olive Health, Inc. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 md:justify-end">
            <a href="#" className="hover:text-foreground">Privacy</a>
            <a href="#" className="hover:text-foreground">Terms</a>
            <a href="#" className="hover:text-foreground">HIPAA notice</a>
            <a href="#" className="hover:text-foreground">Telehealth consent</a>
          </div>
        </div>

        <p className="mt-8 text-[11px] text-foreground/65 leading-relaxed max-w-3xl">
          Olive Health provides telehealth services through independently-owned medical practices. Compounded
          medications are not FDA-approved for safety, effectiveness, or quality. Individual results vary.
          Not a substitute for in-person emergency care. Service not available in all states.
        </p>
      </div>
    </footer>
  );
};
